import React, { useEffect, useState } from "react";
import { Grid, MenuItem } from "@material-ui/core";
import useAutocomplete from "@material-ui/lab/useAutocomplete";
import moment from "moment";
import CheckIcon from "@material-ui/icons/Check";
import { useDispatch, useSelector } from "react-redux";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { baseApiURL, BootstrapInput } from "../../../Utilities/Utility";
import {
  Label,
  InputWrapper,
  Listbox,
  Tag,
  getTodayDate,
} from "../../../Utilities/Utility";
import Loading from "../../../Components/Loader/Loader";
import {
  GetPartDDl,
  GetSupplierEmailDDl,
} from "../../../Redux/APIs/api_Common";
import UseAutocomplete from "../../../Components/Autocomplete/AutoComplete";
import EmailAutocomplete from "../../../Components/Autocomplete/EmailAutoComplete";
import {
  getOPRRespResult,
  getSQMRespResult,
  getSPRRespResult,
  getBARespResult
} from "../../../Redux/APIs/api_view";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import { supplierMailValAction } from "../../../Redux/Actions/actions";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  autocompleteRoot: {
    width: '100%',
    marginTop: '0px',
    background: 'unset !important',
    '& .MuiInputBase-root': {
      height: '40px',
      padding: '0px 8px',
      border: '1px solid #008AA6 !important',
      borderRadius: '4px',
      boxShadow: 'none !important',
      marginTop: '8px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 0px',
      fontSize: '14px',
    },
  },
  inputField: {
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
  },
}));

export default function CreateComplaintDetails(props) {
  const classes = useStyles();
  console.log("props", props);
  const dispatch = useDispatch();
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );

  let [isLoader, setIsLoader] = useState(false);
  const [ccOptions, setCcOptions] = useState([]);
  //azure ad
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const handleChangeSupplierInputs = (event, value) => {
    let elem = event.target.name;
    switch (elem) {
      case "supplierEmail":
        const supplierName = supplierEmail.find(
          (x) => x.id === value.props.value
        )?.name;
        const CCEmails = supplierEmail.find(
          (x) => x.id === value.props.value
        )?.ccEmails;
        const supplierCode = supplierEmail.find(
          (x) => x.id === value.props.value
        )?.code;
        setCcOptions(CCEmails);
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            id: value.props.value,
            supplierId: value.props.value,
            supplierName: supplierName,
            suppliernumber: supplierCode,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: value.props.value,
            supplierId: value.props.value,
            supplierNameAuto: supplierName,
            supplierNumberAuto: supplierCode,
          });
        }

        break;
      case "partNumber":
        const partDesc = partNumber.find(
          (x) => x.id === value.props.value
        )?.partDesc;
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            partId: value.props.value,
            partDescription: partDesc,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: value.props.value,
            partDescription: partDesc,
          });
        }

        break;
      case "supplierPo":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "ccEmail":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs((old) => {
            return {
              ...props.draftInputs,
              ...old,
              cclist: value.props.value,
            };
          });
        } else {
          props.setCreateComplaintInputs((old) => {
            return {
              ...props.createComplaintInputs,
              ...old,
              [elem]: value.props.value,
            };
          });
        }
        break;
      case "supplierInvoice":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "deliveredQuantity":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            deliveredQty: parseInt(event.target.value),
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      case "dateCodeBatchLot":
        if (
          props?.rowData?.status === "Draft" ||
          props?.rowData?.status === "Recall" ||
          props?.rowData?.status === "Sent back to Siemens"
        ) {
          props.setDraftInputs({
            ...props.draftInputs,
            [elem]: event.target.value,
          });
        } else {
          props.setCreateComplaintInputs({
            ...props.createComplaintInputs,
            [elem]: event.target.value,
          });
        }
        break;
      default:
        break;
    }
  };
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: "customized-hook-demo",
    name: "ccEmail",
    multiple: true,
    defaultValue: props?.rowData?.status
      ? (props?.rowData?.cclist).map((item, key) => props?.rowData?.cclist[key])
      : [],
    options: ccOptions || [],
    getOptionLabel: (option) => option,
    onChange: (e, value) => {
      if (
        props?.rowData?.status === "Draft" ||
        props?.rowData?.status === "Recall" ||
        props?.rowData?.status === "Sent back to Siemens"
      ) {
        props.setDraftInputs((old) => {
          return {
            ...old,
            cclist: value,
          };
        });
      } else {
        props.setCreateComplaintInputs((old) => {
          return {
            ...old,
            cclist: value,
          };
        });
      }
    },
  });

  const [defaIndex, setDefaIndex] = useState(null);
  function findDefSupplerMailIdx() {
    let defaIndexVal = supplierEmail.findIndex(
      (x) => x.id == props.draftInputs.id
    );
    setDefaIndex(defaIndexVal);
    console.log("Index", defaIndex);
  }
  const [supplierEmail, setSupplierEmail] = useState([]);
  async function SupplierEmailDDL() {
    const response = await GetSupplierEmailDDl(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    );
    if (response && response?.length > 0) {
      setSupplierEmail(response);
    } else {
      setSupplierEmail([
        {
          id: 0,
          name: "No Options",
        },
      ]);
    }
  }

  //var defaIndex = null;
  // useEffect(() => {
  //   findDefSupplerMailIdx();
  // }, [supplierEmail]);

  const [partNumber, setPartNumber] = useState([]);
  async function PartNumberDDL() {
    setIsLoader(true);
    const response = await GetPartDDl(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    );
    if (response && response?.length > 0) {
      setIsLoader(false);
      setPartNumber(response);
    } else {
      setPartNumber([
        {
          id: 0,
          name: "No Options",
        },
      ]);
    }
  }
  function onChangePartNumber(event, value) {
    const partDesc = partNumber.find((x) => x.id === value.id)?.partDesc;
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        partId: value.id,
        partNumber: value.partNumber,
        partDescription: partDesc,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        partNumber: value.id,
        partDescription: partDesc,
      });
    }
  }
  function onChangeSupplierEmail(event, value) {
    const supplierName = supplierEmail.find((x) => x.id === value.id)?.name;
    const CCEmails = supplierEmail.find((x) => x.id === value.id)?.ccEmails;
    const supplierCode = supplierEmail.find((x) => x.id === value.id)?.code;
    setCcOptions(CCEmails);
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        id: value.id,
        supplierId: value.supplierId,
        supplierUserId: value.id,
        supplierName: supplierName,
        suppliernumber: supplierCode,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        id: value.id,
        supplierEmail: value.id,
        supplierId: value.supplierId,
        supplierUserId: value.id,
        supplierNameAuto: supplierName,
        supplierNumberAuto: supplierCode,
      });
    }
  }
  const [disable, setDisable] = useState(true);
  function disableForm() {
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData === "" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      if (
        props?.rowData?.status === "Sent back to Siemens" &&
        userDetails.roleId === 3
      ) {
        setDisable(true);
      } else {
        setDisable(false);
      }
    } else {
      setDisable(true);
    }
  }

  const [sqmDropdownObj, setSQMDropdownObj] = useState([]);
  function getSQMRespObj() {
    getSQMRespResult(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setSQMDropdownObj(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const [oprDropdownObj, setOPRDropdownObj] = useState([]);
  function getOPRRespObj() {
    getOPRRespResult(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setOPRDropdownObj(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }


  const [sprDropdownObj, setSPRDropdownObj] = useState([]);
  function getSPRRespObj() {
    getSPRRespResult(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setSPRDropdownObj(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [baDropdownObj, setBADropdownObj] = useState([]);
  function getBARespObj() {
    getBARespResult(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setBADropdownObj(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    console.log("Comp Deatil Props", props);
    if (props) {
      disableForm();
    }
    // SupplierEmailDDL();
    PartNumberDDL();
    getSQMRespObj();
    getOPRRespObj();
    getSPRRespObj();
    getBARespObj();
  }, []);

  const [sqmResp, setSQMResp] = useState([]);
  const handleSQMRespChange = (e) => {
    setSQMResp(e.target.value);

    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        SQMResponsibleId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        SQMResponsibleId: e.target.value,
      });
    }
  };
  const [oprResp, setOPRResp] = useState([]);
  const handleOPRRespChange = (e) => {
    setOPRResp(e.target.value);
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        OPRResponsibleId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        OPRResponsibleId: e.target.value,
      });
    }
  };

  const [sprResp, setSPRResp] = useState([]);
  const handleSPRRespChange = (e) => {
    setSPRResp(e.target.value);
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        SPRResponsibleId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        SPRResponsibleId: e.target.value,
      });
    }
  };

  const [baResp, setBAResp] = useState([]);
  const handleBaRespChange = (e) => {
    setBAResp(e.target.value);
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        BAResponsibleId: e.target.value,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        BAResponsibleId: e.target.value,
      });
    }
  };

  // let defaultValue = null;
  // useEffect(() => {
  //   defaultValue = supplierEmail.find(
  //     (item) => item.email === props?.rowData?.supplierEmail
  //   );
  // }, [supplierEmail])

  const [selectedEmail, setSelectedEmail] = useState(null);

  const handleChange = (event, value) => {
    const selected = supplierEmail.find((item) => item.email === value);
    if (selected) {
      console.log("Selected ID:", selected.id);
      console.log("Selected Supplier ID:", selected.supplierId);
      setSelectedEmail(selected);
    }
    dispatch(supplierMailValAction(selected))

    const supplierName = supplierEmail.find((x) => x.email === value)?.name;
    const CCEmails = supplierEmail.find((x) => x.email === value)?.ccEmails;
    const supplierCode = supplierEmail.find((x) => x.email === value)?.code;
    setCcOptions(CCEmails);
    if (
      props?.rowData?.status === "Draft" ||
      props?.rowData?.status === "Recall" ||
      props?.rowData?.status === "Sent back to Siemens"
    ) {
      props.setDraftInputs({
        ...props.draftInputs,
        id: selected.id,
        supplierId: selected.supplierId,
        supplierUserId: selected.id,
        supplierName: supplierName,
        suppliernumber: supplierCode,
      });
    } else {
      props.setCreateComplaintInputs({
        ...props.createComplaintInputs,
        id: selected.id,
        supplierEmail: selected.id,
        supplierId: selected.supplierId,
        supplierUserId: selected.id,
        supplierNameAuto: supplierName,
        supplierNumberAuto: supplierCode,
      });
    }

  };

  useEffect(() => {
    setIsLoader(true);
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + siteToken.token,
        AzureToken: azureToken.token,
        UserEmail: userDetails.userEmail,
        RoleName: userDetails.role,
        Gid: userDetails.gid,
        Roleid: userDetails.roleId,
        userId: UID.id,
      },
    };

    // Simulate API call
    axios.get(baseApiURL + "/Common/GetSupplierEmailDDL",
      options)
      .then((response) => {
        const data = response.data?.result;
        setSupplierEmail(data);

        // Set default value after data is loaded
        let defaultValue = null;
        if (props.rowData !== null) {
          defaultValue = data.find(
            (item) => item.name === props?.rowData?.supplierName
          );
          setSelectedEmail(defaultValue);
        }
        // if (defaultValue) {
        //   setSelectedEmail(defaultValue);
        // }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.error("Error fetching supplier emails:", error);
      });
  }, []);


  return (
    <>
      <div className="main-block">
        <Grid container spacing={2}>
                  <Grid item xs={12} sm={7} md={12} className="left-div">
                      <h3 className="heading">Non Conformity Notification</h3>
                  </Grid>
                 
                 
              </Grid>
              {/*<Grid item xs={12} sm={5} md={2} className="complaint-id" >*/}
              {/*    <h4 style={{ background: "var(--btn-hero-bg-hover)" }}>*/}
              {/*        Date :*/}
              {/*        {props?.rowData?.raiseDate*/}
              {/*            ? moment(props?.rowData?.raiseDate).format("MM/DD/YYYY")*/}
              {/*            : getTodayDate()}*/}
              {/*    </h4>*/}
              {/*</Grid>*/}
        <Grid container spacing={2} className="complaint-id">
                  <Grid item xs={12} sm={5} md={2}>
                      <h4 style={{ background: "var(--btn-hero-bg-hover)" }}>
                          Date :
                          {props?.rowData?.raiseDate
                              ? moment(props?.rowData?.raiseDate).format("MM/DD/YYYY")
                              : getTodayDate()}
                      </h4>
            <h4 style={{ background: "var(--btn-hero-bg-hover)" }}>
              Complaint Id :{" "}
              {props.rowData?.status
                ? props.rowData?.name
                  ? props.complaintDetails.complaintNumber
                  : props.rowData?.complaintNumber
                : props.complaintDetails.complaintNumber}
            </h4>
          </Grid>
        </Grid>

        <Grid container className="complaint-id"></Grid>
        <Grid>
          <Grid className="mt-10">
            <Grid container spacing={2} md={12}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    Sender Name
                  </InputLabel>
                  <BootstrapInput
                    value={
                      props.rowData
                        ? props.rowData?.senderName
                        : userDetails.userFirstName
                    }
                    id="Sender-Name"
                    name="senderName"
                    disabled={disable}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl
                  error={
                    props.rowData
                      ? props.rowData.status === "Draft" ||
                        props.rowData.status === "Recall"
                        ? !props.draftInputs.supplierId
                        : !props.rowData.supplierId
                      : !props.createComplaintInputs.supplierEmail
                  }
                  fullWidth
                >
                  <InputLabel shrink htmlFor="bootstrap-input" style={{ color: "black" }}>
                    Supplier Email **
                  </InputLabel>
                  <Autocomplete
                    freeSolo
                    className={classes.autocompleteRoot}
                    disableClearable
                    id="free-solo-2-demo"
                    disabled={disable}
                    options={supplierEmail?.map((option) => option.email)}
                    value={selectedEmail?.email || ''}
                    onChange={handleChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        InputProps={{ ...params.InputProps, type: 'search' }}
                      />
                    )}
                  />

                </FormControl>
              </Grid>

              <Grid className="autocomplete-pr" item xs={12} sm={6} md={3}>
                <div style={{ padding: "2px" }} {...getRootProps()}>
                  <Label {...getInputLabelProps()}>CC(Optional)</Label>
                  <InputWrapper
                    ref={setAnchorEl}
                    className={focused ? "focused" : ""}
                  >
                    {value.map((option, index) => (
                      <Tag label={option} {...getTagProps({ index })} />
                    ))}

                    <input
                      disabled={disable}
                      {...getInputProps()}
                      onInputChange={handleChangeSupplierInputs}
                    />
                  </InputWrapper>
                </div>
                {groupedOptions?.length > 0 ? (
                  <Listbox {...getListboxProps()}>
                    {groupedOptions?.map((option, index) => (
                      <li {...getOptionProps({ option, index })}>
                        <span>{option}</span>
                        <CheckIcon fontSize="small" />
                      </li>
                    ))}
                  </Listbox>
                ) : null}
              </Grid>
            </Grid>
            <Grid container spacing={2} md={12}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    SQM Responsible **
                  </InputLabel>
                  <Select
                    labelId="SQM Resonsible"
                    id="sqmResp"
                    name="sqmResp"
                    disabled={disable}
                    onChange={handleSQMRespChange}
                    // value={sqmResp}
                    defaultValue={
                      props.rowData
                        ? props.rowData.status === "Draft" ||
                          props.rowData.status === "Recall" ||
                          props?.rowData?.status === "Sent back to Siemens"
                          ? props.draftInputs.SQMResponsibleId
                          : props.rowData.sqmResponsibleId
                        : props.createComplaintInputs.sqmResponsibleId
                    }
                    // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                    input={<BootstrapInput />}
                  >
                    {sqmDropdownObj.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.email}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    OPR Responsible **
                  </InputLabel>
                  <Select
                    labelId="OPR Resonsible"
                    id="oprResp"
                    name="oprResp"
                    disabled={disable}
                    onChange={handleOPRRespChange}
                    // value={oprResp}
                    defaultValue={
                      props.rowData
                        ? props.rowData.status === "Draft" ||
                          props.rowData.status === "Recall" ||
                          props?.rowData?.status === "Sent back to Siemens"
                          ? props.draftInputs.OPRResponsibleId
                          : props.rowData.oprResponsibleId
                        : props.createComplaintInputs.oprResp
                    }
                    // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                    input={<BootstrapInput />}
                  >
                    {oprDropdownObj.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.email}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    SPR Responsible **
                  </InputLabel>
                  <Select
                   disabled={disable}
                    labelId="SPR Responsible"
                    id="sprResp"
                    name="sprResp"
                    onChange={handleSPRRespChange}
                    // value={oprResp}
                    defaultValue={
                      props.rowData
                        ? props.rowData.status === "Draft" ||
                          props.rowData.status === "Recall" ||
                          props?.rowData?.status === "Sent back to Siemens"
                          ? props.draftInputs.SPRResponsibleId
                          : props.rowData.sprResponsibleId
                        : props.createComplaintInputs.sprResp
                    }
                    // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                    input={<BootstrapInput />}
                  >
                    {sprDropdownObj.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.email}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel shrink htmlFor="bootstrap-input">
                    BA Responsible **
                  </InputLabel>
                  <Select
                    labelId="BA Responsible"
                    id="baResp"
                    name="baResp"
                    disabled={disable}
                    onChange={handleBaRespChange}
                    // value={oprResp}
                    defaultValue={
                      props.rowData
                        ? props.rowData.status === "Draft" ||
                          props.rowData.status === "Recall" ||
                          props?.rowData?.status === "Sent back to Siemens"
                          ? props.draftInputs.BAResponsibleId
                          : props.rowData.baResponsibleId
                        : props.createComplaintInputs.baResp
                    }
                    // disabled={userDetails.roleId == 3 || userDetails.roleId == 4 || userDetails.roleId == 5 || userDetails.roleId == 7 || userDetails.roleId == 8 || userDetails.roleId == 9 || userDetails.roleId == 10}
                    input={<BootstrapInput />}
                  >
                    {baDropdownObj.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.email}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} className="view-block">
          <Grid item xs={12} sm={6} md={3}>
            <UseAutocomplete
              title="Part Number **"
              onChange={onChangePartNumber}
              defaultValue={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    (props?.rowData?.status === "Sent back to Siemens" &&
                      userDetails.roledId !== 3)
                    ? props.draftInputs.partNo
                    : {
                      partId: props.rowData.partId,
                      partNumber: props.rowData.partNumber,
                    }
                  : props.createComplaintInputs.partId
              }
              disable={disable}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl
              error={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? !props.draftInputs.partDescription
                    : !props.rowData.partDescription
                  : !props.createComplaintInputs.partDescription
              }
              fullWidth
            >
              <InputLabel
                shrink
                htmlFor="bootstrap-input"
                name="partDescription"
                style={{ color: "#000028" }}
              >
                Part Description **
              </InputLabel>
              <BootstrapInput
                className="partdesc-top"
                value={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? props.draftInputs.partDescription
                      : props.rowData.partDescription
                    : props.createComplaintInputs.partDescription
                }
                multiline
                disabled={disable}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl
              error={
                props.rowData
                  ? props.rowData.status === "Draft" ||
                    props.rowData.status === "Recall" ||
                    props?.rowData?.status === "Sent back to Siemens"
                    ? !props.draftInputs.supplierName
                    : !props.rowData.supplierName
                  : !props.createComplaintInputs.supplierNameAuto
              }
              fullWidth
            >
              <InputLabel
                shrink
                htmlFor="bootstrap-input"
                name="supplierNameAuto"
                style={{ color: "#000028" }}
              >
                Supplier Name **
              </InputLabel>
              <BootstrapInput
                value={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? props.draftInputs.supplierName
                      : props.rowData.supplierName
                    : props.createComplaintInputs.supplierNameAuto
                }
                disabled={disable}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel
                shrink
                htmlFor="bootstrap-input"
                name="supplierNumberAuto"
              >
                Supplier Number
              </InputLabel>
              <BootstrapInput
                value={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? props.draftInputs.suppliernumber
                      : props.rowData.suppliernumber
                    : props.createComplaintInputs.supplierNumberAuto
                }
                disabled={disable}
                id="bootstrap-input"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Supplier PO
              </InputLabel>
              <BootstrapInput
                id="bootstrap-input"
                name="supplierPo"
                type="text"
                value={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? props.draftInputs.supplierPo
                      : props.rowData.supplierPo
                    : props.createComplaintInputs.supplierPo
                }
                disabled={disable}
                onChange={handleChangeSupplierInputs}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Supplier InVoice
              </InputLabel>
              <BootstrapInput
                id="bootstrap-input"
                name="supplierInvoice"
                value={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? props.draftInputs.supplierInvoice
                      : props.rowData.supplierInvoice
                    : props.createComplaintInputs.supplierInvoice
                }
                disabled={disable}
                onChange={handleChangeSupplierInputs}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Delivered Quantity
              </InputLabel>
              <BootstrapInput
                id="bootstrap-input"
                name="deliveredQuantity"
                type="number"
                inputProps={{ min: 0 }}
                disabled={disable}
                value={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? props.draftInputs.deliveredQty
                      : props.rowData.deliveredQty
                    : props.createComplaintInputs.deliveredQuantity
                }
                onChange={handleChangeSupplierInputs}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Date Code/Batch/Lot
              </InputLabel>
              <BootstrapInput
                id="bootstrap-input"
                name="dateCodeBatchLot"
                value={
                  props.rowData
                    ? props.rowData.status === "Draft" ||
                      props.rowData.status === "Recall" ||
                      props?.rowData?.status === "Sent back to Siemens"
                      ? props.draftInputs.dateCodeBatchLot
                      : props.rowData.dateCodeBatchLot
                    : props.createComplaintInputs.dateCodeBatchLot
                }
                disabled={disable}
                onChange={handleChangeSupplierInputs}
              />
            </FormControl>
          </Grid>
        </Grid>
      </div>
      {isLoader ? <Loading loaderText="Loading...." /> : <></>}
    </>
  );
}
